import { Document, Page, View, Text } from '@react-pdf/renderer';
import Table from './Table';

const CharacterPDF = ({
    title, styles, characterData,
    generalAbilities,
    investigativeAbilities,
    generalPowers,
    investigativePowers
}) => {
    return (
        <Document title={title} >
            <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                    
                    <Text style={styles.header}>{characterData.name}</Text>
                    <Text style={styles.paragraph}>{characterData.description}</Text>
                    <Text style={styles.h3}>General Abilities</Text>
                    <Table data={generalAbilities} />
                    <Text style={styles.h3}>Investigative Abilities</Text>
                    <Table data={investigativeAbilities} />
                    <Text style={styles.h3}>General Powers</Text>
                    <Table data={generalPowers} />
                    <Text style={styles.h3}>Investigative Powers</Text>
                    <Table data={investigativePowers} />
                    
                </View>
            </Page>
        </Document>
    );
}

export default CharacterPDF;